import { render } from "./VentasCanastillaView.vue?vue&type=template&id=578b02ae"
import script from "./VentasCanastillaView.vue?vue&type=script&lang=js"
export * from "./VentasCanastillaView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__